<div class="header">
  <div *ngIf="!languageSelected">
    <img class="logo-header-spa" src="../../../assets/img/GRUPO-BID-white-spa-vert.png" alt="Logo App">
  </div>
  <div *ngIf="languageSelected">
    <img class="logo-header-eng" src="../../../assets/img/GRUPO-BID-white-eng-vert.png" alt="Logo App">
  </div>
  <app-menu></app-menu>
  <div class="right">
    <div class="info">
      <ng-container *ngIf="username === 'stb'; else elseBlock">
        <p class="name">Javier Henríquez Márquez</p>
      </ng-container>
      <ng-template #elseBlock>
        <p class="name">{{ getUserName() }}</p>
      </ng-template>
      <p>
        <button mat-button [matMenuTriggerFor]="menu">{{languaje.name}}</button>
        <mat-menu #menu="matMenu">
          <button (click)="onClick(lang)" *ngFor="let lang of languages.data" mat-menu-item>{{lang.name}}</button>
        </mat-menu>
      </p>
    </div>
    <a *ngIf="SEC || STB" class="logOut notification" [disabled]="true" style="background: none;padding: 15px 0px 20px 20px;cursor: pointer;" (click)="handlerNotification()">
      <mat-icon [ngClass]="{
        'icon-void':  notifications?.length == 0,
        'icon-notification': notifications?.length > 0
      }" aria-hidden="false" aria-label="notifications">notifications</mat-icon> 
    </a>

    <a style="cursor: pointer;" class="logOut" (click)="handlerCloseSession()">{{ 'stt.home.exit' | translate }}</a>
  </div>
</div>